import { createRoleThunks } from "./roleSliceFactory";
import { VALUER_ENDPOINTS, ROLE_COLLECTION_KEYS } from "../types/roles";

const slice = createRoleThunks(
  "valuer",
  VALUER_ENDPOINTS,
  ROLE_COLLECTION_KEYS.valuer
);

export const valuerThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const valuerActions = slice.actions;

export default slice.reducer;
